module.exports = __webpack_public_path__ + "img/I.099f26c1.jpg";